enum SupplierGuidEnum {
    LMC = "d5f50f96-5c55-4a72-91ea-9f8d4cebf6da",
    BUSINESS_ENVIRONMENTS = "c16e1497-b035-49f9-a401-dfc35850ce09",
    STRAP_ITS = "10497405-4529-417c-98e3-7edbc01f79b3",
    POPMOUNT = "ff93c919-a13c-48b6-bd97-e7423efd8250",
    PREFORM = "709a3451-061a-4a65-8bba-e7aaba3c1ffa",
    DECOVITA = "fcb858ad-d57b-4305-a8bf-ffae8a7e5c95",
    SYNTHAX = "cdffa1a3-4e1a-4100-8e26-60c3b94a96e3",
    BETHELSD = "52240134-2da2-43ec-9a2d-06ae2e89bc75",
    VERMONT = "2cae939a-b7db-40f8-9440-fefd3a7fa133",
    ROCKY_TOP_DELIGHTS = "599b03d7-1ee2-420f-aa41-8b9352ac5065",
    PANASONIC = "d473b43f-5007-43cb-9d4e-d3c56516b130",
    PANASONIC_CA = "630d68a0-2ab3-4396-984e-2a59b28edf2e",
    MEDCO = "c7c8cc01-3286-471d-b8c8-57d8c22f662a",
    TEXAS_TIRE = "5105cd0a-2ee3-431f-a5f2-08bc07cd5cbd",
    FIRE_PIT_MEATS = "c49f803a-8f27-4c7a-80e4-a7fd54c8947e",
    DECORCABLE = "76b386e9-3497-4d3a-bfc5-a1884d5a60b7",
}

export default SupplierGuidEnum;
